import localforage from 'localforage'

class AuthSession {
  constructor() {
    if (!AuthSession.instance) {
      this._localForage = localforage.createInstance({
        name: 'AuthSession',
      })
      AuthSession.instance = this // Cache the instance
    }

    return AuthSession.instance // Return the cached instance
  }

  async getItem(key) {
    try {
      return await this._localForage.getItem(key)
    } catch (e) {
      console.log('Error getting item from local storage', e)
      return null
    }
  }

  async setItem(key, value) {
    try {
      await this._localForage.setItem(key, value)
      return true
    } catch (e) {
      console.log('Error setting item in local storage', e)
      return false
    }
  }

  async deleteItem(key) {
    try {
      await this._localForage.removeItem(key)
      return true
    } catch (e) {
      console.log('Error deleting item from local storage', e)
      return false
    }
  }

  async clearAll() {
    try {
      await this._localForage.clear()
    } catch (e) {
      console.log('Error clearing local storage', e)
    }
  }
}

const instance = new AuthSession() // Create a single instance
Object.freeze(instance) // Freeze the instance to prevent modifications

export default instance // Export the singleton instance
